import { User } from 'lib-shared-types-api';

import { AwayStatus } from 'apis/presence';
import { PresenceRowSelection } from 'components/presence/components/presenceListItem';
import { TeamWithMembers } from 'components/presence/components/presenceListSections';
import { PresenceSection } from 'components/presence/components/presenceSection';
import { PresenceSectionSkeleton } from 'components/presence/components/presenceSectionSkeleton';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';
import { CollapsedSections } from 'components/presence/hooks/useCollapsedSections';

type TeamPresenceListSectionsProps = {
  profile: User;
  awayStatuses: AwayStatus[];
  teams: TeamWithMembers[];
  loading: boolean;
  error: boolean;
  selection: PresenceRowSelection;
  collapsedSections: CollapsedSections;
};

export const TeamPresenceListSections = ({
  profile,
  awayStatuses,
  teams,
  loading,
  error,
  selection,
  collapsedSections,
}: TeamPresenceListSectionsProps): JSX.Element | null => {
  if (error) {
    return <PresenceSectionWarning title="Loading team members failed.." />;
  }

  if (loading) {
    return (
      <>
        <PresenceSectionSkeleton />
        <PresenceSectionSkeleton />
      </>
    );
  }

  if (teams.length === 0) {
    return null;
  }

  const sectionProps = { profile, awayStatuses, selection, collapsedSections };

  return (
    <PresenceSection
      id="teams"
      title="Teams"
      count={teams.length}
      {...sectionProps}
    >
      {teams.map((team) => (
        <PresenceSection
          key={team.id}
          id={`team-${team.id}`}
          title={team.name}
          count={team.members.length}
          members={team.members}
          {...sectionProps}
        />
      ))}
    </PresenceSection>
  );
};
